import { useStore } from '@nanostores/react';
import { storageStatusStore, type StorageStatusState } from '~/lib/stores/storageStatusStore';

export function useStorageStatus(): StorageStatusState {
  const storeState = useStore(storageStatusStore);

  return {
    ...storeState,
  };
}
